import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../App";
import { Button } from "@/components/ui/button";
import {
  BookOpen,
  User,
  LogOut,
  LayoutDashboard,
  Menu,
  X,
} from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/");
    setOpen(false);
  };

  return (
    <nav
      className="border-b bg-white sticky top-0 z-50 shadow-sm"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-2 lg:px-2">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <img
              src="https://blogger.googleusercontent.com/img/a/AVvXsEjojt-7M7DtTdb7KHwt04jsK5cbXaG-CBE48qhHrGyuIcYLT50ObkHWZ8Uc8LzzE7Ys55WEoWwOUoFAI8NA86YGy_oNEr1Mcnx9qblLcG9yZvthmByriDnfe-Oaayltb_jZ2nYw1fR4wVbXW5MHqne23Glp9pRQSmdbDhEmo7ba6r14qw7a_nMN2EE5lbNu=s200"
              alt="Logo"
              className="w-10 h-10"
            />
            <span className="text-xl md:text-2xl font-bold text-[#0f3e3e]">
              Safety Training Institute
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/about" className="nav-link">About</Link>
            <Link to="/courses" className="nav-link">Courses</Link>
            <Link to="/contact" className="nav-link">Contact</Link>
            <Link to="/verify-certificate">Verify Certificate</Link>

            {user ? (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost" className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-[#0f3e3e] rounded-full flex items-center justify-center">
                      <User className="w-4 h-4 text-white" />
                    </div>
                    <span>{user.name}</span>
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-56">
                  <div className="px-2 py-1.5 text-sm">
                    <p className="font-medium">{user.name}</p>
                    <p className="text-xs text-muted-foreground">
                      {user.email}
                    </p>
                  </div>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem
                    onClick={() =>
                      navigate(user.role === "admin" ? "/admin" : "/dashboard")
                    }
                  >
                    <LayoutDashboard className="mr-2 h-4 w-4" />
                    Dashboard
                  </DropdownMenuItem>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem onClick={handleLogout}>
                    <LogOut className="mr-2 h-4 w-4" />
                    Logout
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            ) : (
              <>
                <Link to="/login">
                  <Button variant="ghost">Login</Button>
                </Link>
                <Link to="/signup">
                  <Button className="bg-[#0f3e3e] text-white hover:bg-[#0f3e3e]/90">
                    Sign Up
                  </Button>
                </Link>
              </>
            )}
          </div>

          {/* Mobile Toggle Button */}
          <button
            className="md:hidden"
            onClick={() => setOpen(!open)}
            aria-label="Toggle Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="md:hidden border-t bg-white px-6 py-4 space-y-4">
          <Link to="/" onClick={() => setOpen(false)} className="block">
            Home
          </Link>
          <Link to="/about" onClick={() => setOpen(false)} className="block">
            About
          </Link>
          <Link to="/courses" onClick={() => setOpen(false)} className="block">
            Courses
          </Link>
          <Link to="/contact" onClick={() => setOpen(false)} className="block">
            Contact
          </Link>

          <div className="border-t pt-4">
            {user ? (
              <>
                <button
                  onClick={() => {
                    navigate(
                      user.role === "admin" ? "/admin" : "/dashboard"
                    );
                    setOpen(false);
                  }}
                  className="block w-full text-left mb-2"
                >
                  Dashboard
                </button>
                <button
                  onClick={handleLogout}
                  className="block w-full text-left text-red-600"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)}>
                  <Button variant="ghost" className="w-full mb-2">
                    Login
                  </Button>
                </Link>
                <Link to="/signup" onClick={() => setOpen(false)}>
                  <Button className="w-full bg-[#0f3e3e] text-white">
                    Sign Up
                  </Button>
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
